import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}} % rabat på udvalgte varer',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}} % rabat på samlet ordreværdi',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratis vare ved køb af en vare',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratis vare ved en ordreværdi',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Køb en, få en til halv pris',
  [OFFER_KIND.BOGO]: 'Køb en, få en gratis',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} rabat på udvalgte varer',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} rabat ved en ordreværdi',
};
